import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { LazyImageProvider } from 'trellis-ecosystem';
import { SuggestedCollections } from '../collections/components/SuggestedCollections';
import { UmbrellaCollectionCard } from '../collections/components/UmbrellaCollectionCard';
import { SUGGESTED_COLLECTION_IDS } from '../collections/constants/collections';
import { AllProductsSection } from '../components/AllProductsSection';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { SliderSection } from '../components/SliderSection';
import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { UnifiedHeader } from '../components/headers/UnifiedHeader';
import { HOME_MIN_SECTION_CARD_COUNT } from '../constants/suggestions';
import { Screens } from '../constants/usage';
import { useGates } from '../hooks/useGates';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { SuggestedFilters } from '../solutions/components/SuggestedFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HomeContainer() {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.HOME,
    children: /*#__PURE__*/_jsx(Home, {})
  });
}
export function Home() {
  const {
    loading,
    error,
    data
  } = useGetSuggestionSections({
    minimumSectionCardCount: HOME_MIN_SECTION_CARD_COUNT
  });
  const sections = (data === null || data === void 0 ? void 0 : data.result.sections) || [];
  const gates = useGates();
  useTrackHomepageViewedEvent({
    loading,
    sections: data === null || data === void 0 ? void 0 : data.result.sections
  });
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "1200"
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.HOME,
    children: /*#__PURE__*/_jsx(DashboardPageWithHero, {
      headerComponent: /*#__PURE__*/_jsx(UnifiedHeader, {
        isHomePage: true
      }),
      children: /*#__PURE__*/_jsxs(NavMarker, {
        name: "INDEX_LOAD",
        children: [/*#__PURE__*/_jsx(StorefrontPageMetadata, {
          loading: loading,
          metaDescription: unescapedText('marketplaceStorefront.documentHead.home.metaDescription'),
          title: unescapedText('marketplaceStorefront.documentHead.home.title')
        }), /*#__PURE__*/_jsx(View, {
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsxs(LazyImageProvider, {
            children: [sections === null || sections === void 0 ? void 0 : sections.slice(0, 2).map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
              cards: section.cards,
              context: section.context,
              title: section.title,
              sectionIndex: index,
              sectionType: section.sectionType
            }, index)), /*#__PURE__*/_jsx(View, {
              marginBlockEnd: "1200",
              children: /*#__PURE__*/_jsx(UmbrellaCollectionCard, {
                title: unescapedText('marketplaceStorefront.umbrellaCollections.aiEssentials.title'),
                description: unescapedText('marketplaceStorefront.umbrellaCollections.aiEssentials.description'),
                slug: "ai-essentials"
              })
            }), gates.solutionsSpringSpotlight && /*#__PURE__*/_jsx(SuggestedFilters, {}), sections === null || sections === void 0 ? void 0 : sections.slice(2, 4).map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
              cards: section.cards,
              context: section.context,
              title: section.title,
              sectionIndex: sections.length + index,
              sectionType: section.sectionType
            }, sections.length + index)), /*#__PURE__*/_jsx(SuggestedCollections, {
              collectionIds: SUGGESTED_COLLECTION_IDS
            }), sections === null || sections === void 0 ? void 0 : sections.slice(4).map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
              cards: section.cards,
              context: section.context,
              title: section.title,
              sectionIndex: sections.length + index,
              sectionType: section.sectionType
            }, sections.length + index)), /*#__PURE__*/_jsx(AllProductsSection, {
              hasSecondaryButton: true,
              sectionIndex: sections.length
            })]
          })
        })]
      })
    })
  });
}